module.exports = "<img ng-src=\"{{vm.blobUrl}}\" />\n";